module.exports = __webpack_public_path__ + "static/image-1-52000d8338edd4b530a0120e24844844.jpg";